import { CompanyProfile } from 'models';
import { CompanyHelpers } from 'helpers/CompanyHelpers';
import { RouterHelpers } from 'helpers/RouterHelpers';

import { ChecklistItemType } from 'components/checklist-item/ChecklistItem';
import { useCompanyCount } from 'components/company-profile/hooks/use-company-count';
import { COMPONENT_PROGRESS_LEVELS } from 'components/component-progress/helpers/config';

const useProfileProgress = (company: CompanyProfile) => {
    const { products, referenceDesigns, caseStudies, isLoading } = useCompanyCount(company);

    if (isLoading) {
        return { progress: [], percentage: null, color: undefined, isLoading: true };
    }

    const progress = CompanyHelpers.getProgress(
        company,
        !!products?.total,
        !!referenceDesigns?.total,
        !!caseStudies?.total,
    );

    const percentage = CompanyHelpers.getAverageProgress(progress);

    return {
        progress,
        percentage,
        color: COMPONENT_PROGRESS_LEVELS.find((level) => percentage < level.maxPercent)?.color,
        isLoading: false,
    };
};

const useProgressItems = (company: CompanyProfile): ChecklistItemType[] => {
    return [
        {
            value: 'about',
            label: 'Fill in your company about',
            href: RouterHelpers.urls.profiles.edit(company.slug, 'general'),
        },
        {
            value: 'logos',
            label: 'Add a logo',
            href: RouterHelpers.urls.profiles.edit(company.slug, 'general'),
        },
        {
            value: 'cover',
            label: 'Add a cover image',
            href: RouterHelpers.urls.profiles.edit(company.slug, 'general'),
        },
        {
            value: 'socials',
            label: 'Add your social media links',
            href: RouterHelpers.urls.profiles.edit(company.slug, 'general'),
        },
        {
            value: 'locations',
            label: 'Add your contact information',
            href: RouterHelpers.urls.profiles.edit(company.slug, 'contact'),
        },
        {
            value: 'contactPeople',
            label: 'Add your contact people',
            href: RouterHelpers.urls.profiles.edit(company.slug, 'contact'),
        },
        {
            value: 'products',
            label: 'Add a product to the product catalog',
            href: RouterHelpers.urls.profiles.edit(company.slug, 'products'),
        },
        {
            value: 'referenceDesigns',
            label: 'Create a reference design',
            href: RouterHelpers.urls.profiles.edit(company.slug, 'reference-designs'),
        },
        {
            value: 'caseStudies',
            label: 'Add a case study',
            href: RouterHelpers.urls.profiles.edit(company.slug, 'case-studies'),
        },
    ];
};

export { useProfileProgress, useProgressItems };
